module.exports = __webpack_public_path__ + "static/media/General Surgery-Follow Up Intake-2@3x.47cc1dca.png";